/**
 * OrbAvatar — small CSS-gradient circle standing in for Sara's voice orb
 * where the level-driven call orb (voice/call-orb.tsx) would be overkill
 * (message rows, mode toggles, avatars in lists). Purely presentational —
 * no state, no handlers — so this stays a server component.
 */
import { cn } from '@/lib/utils';
import { ORB_GRADIENTS } from '@/lib/design-tokens';

export const ORB_VARIANT = {
  VOICE: 'voice',
  CHAT: 'chat',
} as const;
export type OrbVariant = (typeof ORB_VARIANT)[keyof typeof ORB_VARIANT];

export interface OrbAvatarProps {
  /** Diameter in px. */
  size: number;
  /** Gradient treatment — voice (brighter/warmer) vs chat (softer). Defaults to 'chat'. */
  variant?: OrbVariant;
  className?: string;
}

export function OrbAvatar({
  size,
  variant = ORB_VARIANT.CHAT,
  className,
}: OrbAvatarProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('shrink-0 rounded-full', className)}
      style={{
        width: size,
        height: size,
        background: ORB_GRADIENTS[variant],
      }}
    />
  );
}
